import * as Element from '../element/main';

interface Data {
  label       : string;
  value       : string;
  lang        : string;
}
interface Dataset extends Data, DOMStringMap {}

interface Input extends Data {
  parent      : HTMLElement,
  id          : string, 
}

export interface Elm extends HTMLDivElement {
  dataset  : Dataset;
}


export function init(elm: Elm) {
  const elms = updateWidget(elm);

  const isIE = document.getElementsByTagName('body')[0].classList.contains('is-ie');

  if (!isIE) {
    elms.input.addEventListener('change', 
      event => elms.mark.classList.toggle('checked')
    );
    elms.svg.addEventListener('click', 
      event => {
        elms.input.click();
        elms.input.focus();
      }
    );
    elms.input.addEventListener('focus',
      event => elms.svg.classList.toggle('focus')
    );
    elms.input.addEventListener('blur',
      event => elms.svg.classList.toggle('focus')
    );
  }

  if (elm.dataset.checked == '1')
    elms.mark.classList.toggle('checked');

}


function updateWidget(elm: Elm) {

  const isIE = document.getElementsByTagName('body')[0].classList.contains('is-ie');

  elm.classList.add('widget');
  elm.classList.add('checkbox-widget');
  if (elm.dataset.lang) elm.classList.add(elm.dataset.lang);

  const input = Element.input({
    parent      : elm,
    id          : `${elm.id}__data`,
    type        : 'checkbox',
    name        : elm.id,
    value       : 'checked',
    checked     : elm.dataset.checked == '1',
  });

  let svg, rect, mark;
  if (!isIE) {
    svg = Element.svg({
      parent      : elm,
      id          : `${elm.id}__svg`,
      viewbox     : '0 0 23 23',
      classes     : ['checkbox-svg'],
    });
    rect = Element.rect({
      parent      : svg,
      id          : `${elm.id}__svg_rect`,
      classes     : ['checkbox-box'],
      x           : '1.5',
      y           : '1.5',
      ry          : '2',
    });
    mark = Element.path({
      parent      : svg,
      id          : `${elm.id}__svg_mark`,
      classes     : ['checkbox-mark'],
      d           : 'm 5.5,11.5 3.7,4 9,-8.6',
    });
  } 
 

  const label = Element.label({
    parent      : elm,
    id          : `${elm.id}__label`,
    htmlFor     : `${elm.id}__data`,
    innerHTML   : elm.dataset.label,
  });

  return {
    input : input,
    mark  : mark,
    svg   : svg,
  };


}
